// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4Qk1Z","title":"styles_title__sHQnV","inputs_wrapper":"styles_inputs_wrapper__ARZVB","input_wrapper":"styles_input_wrapper__M8+Xj"};